import { FC } from 'react';

export const LoginFormContainer: FC = () => {
  return <div></div>;
  // const [form] = Form.useForm<LoginFormFields>();
  // const appMessageApi = AppMessage.useControls();
  // const [formErrors, setFormErrors] = useState<FormFieldsErrors<typeof LoginFormInputs>>(null);
  // const { setAuthingState } = useAuthState();
  // const queryClient = useQueryClient();
  // const navigate = useNavigate();
  // const { pathname } = useLocation();

  // const { mutate: loginMutation, isLoading: loginIsLoading } = useLoginAuthMutation()({
  //   onSuccess: async () => {
  //     setAuthingState(true);

  //     await queryClient.refetchQueries([AuthKeys.GetSession], { exact: true });

  //     navigate(pathname.includes(AppRoutes.Login) ? AppRoutes.Home : pathname);
  //   },
  //   onError: (err) => {
  //     setFormErrors(extractFormErrors<typeof LoginFormInputs>(err));
  //     messageOnError(err, appMessageApi);
  //   }
  // });

  // const initialValues: LoginFormFields = {
  //   login: undefined,
  //   password: undefined
  // };

  // const handleFinish = useCallback((values: LoginFormFields): void => {
  //   setFormErrors(null);
  //   loginMutation(values);
  // }, []);

  // const handleFinishFailed = useCallback((): void => {
  //   setFormErrors(null);
  // }, []);

  // return (
  //   <LoginFormView
  //     form={ form }
  //     formErrors={ formErrors }
  //     formName={ 'login' }
  //     formType={ 'create' }
  //     handleBack={ () => {} }
  //     handleFinish={ handleFinish }
  //     handleFinishFailed={ handleFinishFailed }
  //     initialValues={ initialValues }
  //     isFormLoading={ loginIsLoading }
  //     validationSchema={ loginFormValidationSchema }
  //   />
  // );
};
